import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=416bfe3e&scoped=true&"
import script from "./PostCard.vue?vue&type=script&lang=js&"
export * from "./PostCard.vue?vue&type=script&lang=js&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=416bfe3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416bfe3e",
  null
  
)

export default component.exports